export enum LocalStorageKeys
{
    QR_CODE_TOKEN = 'qr_code_token',
    OWNER_ACCESS_TOKEN = 'owner_access_token',
    OWNER_REFRESH_TOKEN = 'owner_refresh_token',
    CLINICIAN_ACCESS_TOKEN = 'clinician_access_token',
    CLINICIAN_REFRESH_TOKEN = 'clinician_refresh_token',
    ADMIN_ACCESS_TOKEN = 'admin_access_token',
    ADMIN_REFRESH_TOKEN = 'admin_refresh_token'
}
